import React from 'react'

interface State { error: Error | null }

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  constructor(props: { children: React.ReactNode }) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  override render(): React.ReactElement | null {
    if (this.state.error) {
      return (
        <div style={{ padding: 32, fontFamily: 'monospace', background: '#fee', color: '#900', whiteSpace: 'pre-wrap' }}>
          <h2>Runtime Error</h2>
          <strong>{this.state.error.message}</strong>
          <pre style={{ marginTop: 16, fontSize: 12 }}>{this.state.error.stack}</pre>
        </div>
      )
    }
    return this.props.children as React.ReactElement
  }
}
